import { changeRxChangePatient } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { ChangeRxChangePatientRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchChangeRxChangePatient(
  rxChangeId: number,
  data: ChangeRxChangePatientRequestT,
  signal?: AbortSignal
): Promise<unknown> {
  const config = await createLotusRequestConfig({ signal });
  const response = await changeRxChangePatient(rxChangeId, data, config);
  return lotusHealthZod.changeRxChangePatientResponse.parse(response.data);
}
